import { DatePipe } from "@angular/common";
import {
        Component,
        EventEmitter,
        Input,
        OnInit,
        Output,
        ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { DCService } from "../../../services/index";

@Component({
  selector: "bit-dc-print",
  templateUrl: "./bitDcPrint.html",
})
export class bitDcPrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  
  printdata: any = {};
  data: any = {};
  dataList: any = [];
  woDetails: any;
  alphabet: string[];
  predefCol: number;
  userDefCol: number;
  dcList : any = [];
  @Input() set printdt(val: any[]) {
    this.printdata = val;
   
    this.getDesignList(this.printdata.dc_id);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    private dcService: DCService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(id) {
    const params = {
      dc_id: id,
    };
    let that = this;
    that.dcService.dcBitDesignList(params).then((res: any) => {
      that.dcList = res.data;
      console.log(that.dcList);
      for (let i = 0; i < that.dcList.length; i++) {
        that.dcList[i].lump_no = that.dcList[i].lump_no
        
          .toString()
          .padStart(6, "0");
      }
      that.calcPieces();
    });
  }
  calcPieces() {




        this.dcList.forEach((el) => {
          el.sftot =
            Number(el.sf36) +
            Number(el.sf38) +
            Number(el.sf40) +
            Number(el.sf42) +
            Number(el.sf44) +
            Number(el.sf46);

          el.shtot =
            Number(el.sh36) +
            Number(el.sh38) +
            Number(el.sh40) +
            Number(el.sh42) +
            Number(el.sh44) +
            Number(el.sh46);
    
          el.bftot =
            Number(el.bf28) +
            Number(el.bf30) +
            Number(el.bf32) +
            Number(el.bf34) +
            Number(el.bf36);
          el.bhtot =
            Number(el.bh28) +
            Number(el.bh30) +
            Number(el.bh32) +
            Number(el.bh34) +
            Number(el.bh36);
    
          el.tot =
            Number(el.sftot) +
            Number(el.shtot) +
            Number(el.bhtot) +
            Number(el.bftot);
        });

        let totmtr = 0;
        let ftot = 0;
       let htot = 0;
       let tf36 = 0;
       let tf38 = 0;
       let tf40 = 0;
       let tf42 = 0;
       let tf44 = 0;
       let tf46 = 0;
       let th36 = 0;
       let th38 = 0;
       let th40 = 0;
       let th42 = 0;
       let th44 = 0;
       let th46 = 0;
       let total = 0;
       let bftot = 0;
       let bhtot = 0;
       let tbf28 = 0;
       let tbf30 = 0;
       let tbf32 = 0;
       let tbf34 = 0;
       let tbf36 = 0;
       let tbh28 = 0;
       let tbh30 = 0;
       let tbh32 = 0;
       let tbh34 = 0;
       let tbh36 = 0;
      for (let i = 0; i < this.dcList.length; i++) {
        const dcdata = this.dcList[i];
        
        totmtr += dcdata.qty;
         ftot += dcdata.sftot;
         htot += dcdata.shtot;
         bftot += dcdata.bftot;
         bhtot += dcdata.bhtot;
         tf36 += dcdata.sf36;
         tf38 += dcdata.sf38;
         tf40 += dcdata.sf40;
         tf42 += dcdata.sf42;
         tf44 += dcdata.sf44;
         tf46 += dcdata.sf46;
         th36 += dcdata.sh36;
         th38 += dcdata.sh38;
         th40 += dcdata.sh40;
         th42 += dcdata.sh42;
         th44 += dcdata.sh44;
         th46 += dcdata.sh46;
         tbf28 += dcdata.bf28;
         tbf30 += dcdata.bf30;
         tbf32 += dcdata.bf32;
         tbf34 += dcdata.bf34;
         tbf36 += dcdata.bf36;
         tbh28 += dcdata.bh28;
         tbh30 += dcdata.bh30;
         tbh32 += dcdata.bh32;
         tbh34 += dcdata.bh34;
         tbh36 += dcdata.bh36;
         total += dcdata.tot
  
      }
        this.data.qty = totmtr;
      this.data.sf36 = tf36;
      this.data.sf38 = tf38;
      this.data.sf40 = tf40;
      this.data.sf42 = tf42;
      this.data.sf44 = tf44;
      this.data.sf46 = tf46;
      this.data.sftot = ftot;
      this.data.sh36 = th36;
      this.data.sh38 = th38;
      this.data.sh40 = th40;
      this.data.sh42 = th42;
      this.data.sh44 = th44;
      this.data.sh46 = th46;
      this.data.shtot = htot;
      this.data.bf28 = tbf28;
      this.data.bf30 = tbf30;
      this.data.bf32 = tbf32;
      this.data.bf34 = tbf34;
      this.data.bf36 = tbf36;
      this.data.bh28 = tbh28;
      this.data.bh30 = tbh30;
      this.data.bh32 = tbh32;
      this.data.bh34 = tbh34;
      this.data.bh36 = tbh36;
      this.data.bhtot = bhtot;
      this.data.bftot = bftot;
      this.data.tot = total;
     this.dcList.push(this.data);
      console.log(this.dcList);

      }
  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=1000");

    /*mywindow.document.write('<html><head><title>Print</title>');
    mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitDc/bitDcPrint.ts